<template>
  <div v-show="show" class="vue-pdfmake-container">
    <slot name="background" />
    <slot name="header" :currentPage="1" :pageCount="1" :pageSize="1" />
    <slot />

    <slot name="footer" :currentPage="1" :pageCount="1" />
  </div>
</template>

<script>
import pdfMake from "./lib/pdfmake.js";

import { PAGE_SIZE, PAGE_ORIENTATION } from "./lib/config.js";

export default {
  props: {
    content: Array,
    show: {
      type: Boolean,
      default: true,
    },
    pageSize: {
      type: String,
      default: "A4",
      validator(value) {
        return PAGE_SIZE.includes(value);
      },
    },
    pageOrientation: {
      type: String,
      default: "portrait",
      validator(value) {
        return PAGE_ORIENTATION.includes(value);
      },
    },
    pageMargins: {
      type: Array,
      default() {
        return [30, 10, 30, 10];
      },
    },
    info: {
      type: Object,
      default() {
        return {};
      },
    },
    styles: {
      type: Object,
      default() {
        return {
          title: {
            fontSize: 18,
            alignment: "center",
            bold: true,
            margin: [0, 20, 0, 5],
          },
          titleOnly: {
            fontSize: 18,
            alignment: "center",
            bold: true,
            margin: [0, 5, 0, 2],
          },
          subtitle: {
            fontSize: 14,
            alignment: "center",
            bold: false,
            margin: [0, 0, 0, 20],
          },
          subtitleLeft: {
            fontSize: 14,
            alignment: "left",
            bold: true,
            margin: [0, 12, 0, 12],
          },
          header: {
            fontSize: 14,
            alignment: "left",
            bold: true,
            margin: [0, 10, 0, 5],
          },
          paragraph: {
            fontSize: 12,
            alignment: "left",
            margin: [0, 15, 0, 5],
            lineHeight: 1.5,
          },
          labelValue: {
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 5],
            lineHeight: 1.125,
          },
          ul: {
            fontSize: 12,
            alignment: "left",
            margin: [0, 5, 0, 10],
          },
          bigger: {
            fontSize: 24,
            italics: true,
          },
          sign: {
            alignment: "center",
          },
          gap: {
            margin: [0, 5, 0, 5],
          },
        };
      },
    },
    defaultStyle: {
      type: Object,
      default() {
        return {
          columnGap: 20,
        };
      },
    },
  },
  data() {
    return {
      docDefinition: {
        info: this.info,
        pageSize: this.pageSize,
        pageOrientation: this.pageOrientation,
        pageMargins: this.pageMargins,
        background: this.background,
        header: this.header,
        content: this.content,
        footer: this.footer,
        defaultStyle: this.defaultStyle,
        styles: this.styles,
      },
    };
  },
  // mounted() {
  //   // this.createPdf();
  //   const pdfDocGenerator = pdfMake.createPdf(this.docDefinition)
  //   pdfDocGenerator.getDataUrl(dataUrl => {
  //     ////console.log('changed');
  //     ////console.log(dataUrl);
  //     ////console.log(this.docDefinition);
  //     this.$emit('change', dataUrl)
  //   })
  // },
  watch: {
    content: function(value) {
      // this.createPdf();
      ////console.log(this.docDefinition);
      this.docDefinition.content = value;
      const pdfDocGenerator = pdfMake.createPdf(this.docDefinition);
      pdfDocGenerator.getDataUrl((dataUrl) => {
        ////console.log('changed');
        ////console.log(dataUrl);
        ////console.log(this.docDefinition);
        this.$emit("change", dataUrl);
      });
    },
  },
};
</script>
<style>
.vue-pdfmake-container * {
  display: block;
  color: #000000;
  padding: 0 !important;
  margin: 0;
}

.vue-pdfmake-container a {
  text-decoration: none;
}
</style>
